export const pageValueIsSet = (page, key) => {
    return !!page && !!page.data && !!page.data[key] && !!page.data[key].value
}

export const renderPageValue = (page, key, defaultValue) => {
    return pageValueIsSet(page, key) ? page.data[key].value : defaultValue;
}

export default {
    pageValueIsSet,
    renderPageValue
}
